import { defineStore } from 'pinia'
import api from '@/api/modules/other'
import { useNavigationHistoryStore } from '@/stores/navigationHistory'

export const useUserPreferencesStore = defineStore('userPreferences', {
  state: () => ({
    table: {},
    navigation: {},
    filterValue: {
      cnpjKycCalcApplicantType: 'kyc',
      cnpjKycCalcProduct: 'current_account'
    }
  }),
  actions: {
    getFilterValuePreferences (type) {
        if (type in this.filterValue) {
            return this.filterValue[type]
          }
          return null
    },
    getTablePreferences (tableName) {
      console.log("getTablePreferences")
      if (tableName in this.table) {
        return this.table[tableName]
      }
      return null
    },
    setChosenColumns(payload){
        if (!(payload.tableName in this.table) || !this.table[payload.tableName]) {
            this.table[payload.tableName] = {
            chosen_columns: payload.chosen_columns,
            ...(payload.tableVersion ? {version: payload.tableVersion} : {})
          }
        } else {
            this.table[payload.tableName].chosen_columns = payload.chosen_columns
          if(payload.tableVersion)
            this.table[payload.tableName].version = payload.tableVersion
        }
        this.table = JSON.parse(JSON.stringify(this.table))
    },
    setQuickViewFields(payload){
      console.log("setQuickViewFields")

      if (!(payload.tableName in this.table) || !this.table[payload.tableName]) {
          this.table[payload.tableName] = {quick_view_fields: payload.quick_view_fields}
      } else {
          this.table[payload.tableName].quick_view_fields = payload.quick_view_fields
      }
      this.table = JSON.parse(JSON.stringify(this.table))
    },
    setPerPage(payload){
      if (!(payload.tableName in this.table) || !this.table[payload.tableName]) {
          this.table[payload.tableName] = {per_page: payload.per_page}
      } else {
          this.table[payload.tableName].per_page = payload.per_page
      }
      this.table = JSON.parse(JSON.stringify(this.table))

    },
    setTableVersion(tableName, version){
      if ((tableName in this.table) && this.table[tableName] && version) {
          if (version === '_delete')
          delete this.table[tableName].version
          else
          this.table[tableName].version = version
      }
      this.table = JSON.parse(JSON.stringify(this.table))
    },
    clearTableStoreSettings(tableName) {
      if (tableName in this.table) {
        delete this.table[tableName]
      }
      this.table = JSON.parse(JSON.stringify(this.table))

    },
    getNavigationPreferences (type) {
        if (type in this.navigation) {
         return this.navigation[type]
        }
        return null
    },
    setNavigation(payload){
        const navigationHistory = useNavigationHistoryStore();
        payload['url']=navigationHistory.lastUrl.raw

        if (!(payload.section in this.navigation)) {
            this.navigation[payload.section] = {}
        }
        if (payload.level_2) {
            this.navigation[payload.section][payload.level_1] = payload.level_2
        } else {
            this.navigation[payload.section]['latest'] = payload.level_1
        }
        this.navigation = JSON.parse(JSON.stringify(this.navigation))
    },
    setLastClickedTab(payload) {
        const navigationHistory = useNavigationHistoryStore();
        payload['url']=navigationHistory.lastUrl.raw

        if (!(payload.section in this.navigation)) {
            this.navigation[payload.section] = {}
        }
        if (payload.level_2) {
            this.navigation[payload.section][payload.level_1] = payload.level_2
        } else {
            this.navigation[payload.section]['latest'] = payload.level_1
        }
        api.tab_click_data(payload)
        this.navigation = JSON.parse(JSON.stringify(this.navigation))

    },
    setFilterValue(payload){
      this.filterValue[payload.section] = payload.sectionValue
      this.filterValue = JSON.parse(JSON.stringify(this.filterValue))
    },
    deleteFilterEntry(payload) {
      if(payload && payload.section){
        delete this.filterValue[payload.section]
        this.filterValue = JSON.parse(JSON.stringify(this.filterValue))
      }
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'user-preferences-store',
        storage: localStorage,
      },
    ],
  }
})
